import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";

// Configuração do Firebase vinda das variáveis de ambiente
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Inicialização segura do Firebase App
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Exportação das instâncias dos serviços
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const southAmericaFunctions = getFunctions(app, "southamerica-east1");
const storage = getStorage(app);

// Conectar ao emulador se a variável de ambiente estiver definida
if (process.env.REACT_APP_USE_EMULATOR === "true") {
    console.warn("🔥 Conectando ao Firebase Emulators (Ambiente Local)");
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    connectFunctionsEmulator(southAmericaFunctions, "127.0.0.1", 5001);
    connectStorageEmulator(storage, "127.0.0.1", 9199);
}

export { auth, db, functions, southAmericaFunctions, storage };
